import { gql } from '@apollo/client';
import React from 'react';
import { Breakpoint } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { DesktopNavigatorFragment, SiteNavFragment } from '../../generated/types';
import { MobileNavV2 } from '../MobileNavV2';
import { DesktopSiteNav, DESKTOP_SITE_NAV_FRAGMENT } from './DesktopSiteNav';
import { MobileSiteNav } from './MobileSiteNav';

import './SiteNav.scss';

export const SITE_NAV_FRAGMENT = gql`
  fragment SiteNavFragment on DisplayPage {
    ...DesktopSiteNavFragment
  }
  ${DESKTOP_SITE_NAV_FRAGMENT}
`;

interface Props {
  displayPage?: SiteNavFragment | null;
  desktopNavigator?: DesktopNavigatorFragment | null;
}

const useMobileNavV2FeatureFlag = () =>
  useFeatureFlag('mobile-nav-v2', [{ default: false }, { if: true, then: true }]);

export const SiteNav: React.FC<Props> = ({ displayPage, desktopNavigator }) => {
  const isMobileNavV2Enabled = useMobileNavV2FeatureFlag();

  return (
    <div className="SiteNav">
      <Breakpoint gt="md">
        <DesktopSiteNav displayPage={displayPage} desktopNavigator={desktopNavigator} />
      </Breakpoint>

      <Breakpoint lt="md">
        {!isMobileNavV2Enabled && <MobileSiteNav />}

        {isMobileNavV2Enabled && <MobileNavV2 />}
      </Breakpoint>
    </div>
  );
};
